// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file identity/v1/settings_service.proto (package identity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { BrowserData, CardNetwork, MerchantSettingsSource, PaymentGatewayType } from "../../common/v1/common_pb";
import { CreateExperimentPayload, CreateMerchantSettingsPayload, CreateSegmentPayload, Experiment, ExperimentStatus, ExperimentWithResults, IntegrationType, Layout, Mandate, MerchantSettings, MerchantSettingsMeta, MerchantSettingsStatus, OrdersOnHpp, PageHeader, PaymentButtonName, PaymentMethods, ReferenceData, SecuritySettings, Segment, TaxIntegration } from "../../common/v1/merchant_settings_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Struct } from "../../google/protobuf/struct_pb";
import { FieldMask } from "../../google/protobuf/field_mask_pb";
import { StratusConfiguration } from "../../common/v1/merchant_ops_pb";
import { Date } from "../../google/type/date_pb";

/**
 * @generated from message identity.v1.GetMerchantSettingsRequest
 */
export const GetMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "browser_data", kind: "message", T: BrowserData },
  ],
);

/**
 * @generated from message identity.v1.GetMerchantSettingsListRequest
 */
export const GetMerchantSettingsListRequest = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsListRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetMerchantSettingsResponse
 */
export const GetMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.GetMerchantSettingsListResponse
 */
export const GetMerchantSettingsListResponse = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsListResponse",
  () => [
    { no: 1, name: "merchant_settings_meta", kind: "message", T: MerchantSettingsMeta, repeated: true },
  ],
);

/**
 * @generated from message identity.v1.PromoteMerchantSettingsRequest
 */
export const PromoteMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.PromoteMerchantSettingsRequest",
  () => [
    { no: 1, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "active_from", kind: "message", T: Timestamp, opt: true },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.PromoteMerchantSettingsResponse
 */
export const PromoteMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.PromoteMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * *
 * Behavior is as per below:
 * - if only merchant_id is provided, the Settings Service will return the currently ACTIVE Merchant Settings associated with given Merchant.
 * - if also settings_id is provided, the given Settings are returned are provided irrespective of their Status.
 *
 * @generated from message identity.v1.GetMerchantSettingsForBundleRequest
 */
export const GetMerchantSettingsForBundleRequest = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsForBundleRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message identity.v1.GetMerchantSettingsForBundleResponse
 */
export const GetMerchantSettingsForBundleResponse = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsForBundleResponse",
  () => [
    { no: 1, name: "merchant_bundle_settings", kind: "message", T: MerchantBundleSettings },
  ],
);

/**
 * @generated from message identity.v1.MerchantBundleSettings
 */
export const MerchantBundleSettings = proto3.makeMessageType(
  "identity.v1.MerchantBundleSettings",
  () => [
    { no: 1, name: "custom_theme", kind: "message", T: Struct },
    { no: 2, name: "form_config", kind: "message", T: Struct },
    { no: 4, name: "safetech_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "payment_methods", kind: "message", T: PaymentMethods },
    { no: 8, name: "supported_ship_to_country_region", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "merchant_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "integration_type", kind: "enum", T: proto3.getEnumType(IntegrationType) },
    { no: 13, name: "layout", kind: "enum", T: proto3.getEnumType(Layout) },
    { no: 14, name: "orders_on_hpp", kind: "message", T: OrdersOnHpp },
    { no: 15, name: "address_autocomplete_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "payment_button_name", kind: "enum", T: proto3.getEnumType(PaymentButtonName) },
    { no: 18, name: "order_mandates", kind: "message", T: Mandate, repeated: true },
    { no: 19, name: "security_settings", kind: "message", T: SecuritySettings },
    { no: 20, name: "page_header", kind: "message", T: PageHeader },
    { no: 21, name: "supported_payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 22, name: "brand_experience", kind: "message", T: Struct },
    { no: 23, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "billing_address_country_restriction", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: "segment", kind: "message", T: Segment },
    { no: 26, name: "tax_integration", kind: "message", T: TaxIntegration },
    { no: 27, name: "surcharge_fee_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message identity.v1.CardPaymentSetting
 */
export const CardPaymentSetting = proto3.makeMessageType(
  "identity.v1.CardPaymentSetting",
  () => [
    { no: 1, name: "accepted_card_network", kind: "enum", T: proto3.getEnumType(CardNetwork), repeated: true },
  ],
);

/**
 * @generated from message identity.v1.CreateMerchantSettingsRequest
 */
export const CreateMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.CreateMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: CreateMerchantSettingsPayload },
    { no: 2, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "force_update", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "source", kind: "enum", T: proto3.getEnumType(MerchantSettingsSource), opt: true },
  ],
);

/**
 * @generated from message identity.v1.CreateMerchantSettingsResponse
 */
export const CreateMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.CreateMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.GetMerchantSettingsForAdminRequest
 */
export const GetMerchantSettingsForAdminRequest = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsForAdminRequest",
  () => [
    { no: 1, name: "merchant_settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetMerchantSettingsForAdminResponse
 */
export const GetMerchantSettingsForAdminResponse = proto3.makeMessageType(
  "identity.v1.GetMerchantSettingsForAdminResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.GetActiveMerchantSettingsRequest
 */
export const GetActiveMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.GetActiveMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "latest_include_non_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message identity.v1.GetAllActiveMerchantSettingsRequest
 */
export const GetAllActiveMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.GetAllActiveMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetActiveMerchantSettingsResponse
 */
export const GetActiveMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.GetActiveMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.GetAllActiveMerchantSettingsResponse
 */
export const GetAllActiveMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.GetAllActiveMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings, repeated: true },
  ],
);

/**
 * @generated from message identity.v1.GetReferenceDataForMppSettingsRequest
 */
export const GetReferenceDataForMppSettingsRequest = proto3.makeMessageType(
  "identity.v1.GetReferenceDataForMppSettingsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetReferenceDataForMppSettingsResponse
 */
export const GetReferenceDataForMppSettingsResponse = proto3.makeMessageType(
  "identity.v1.GetReferenceDataForMppSettingsResponse",
  () => [
    { no: 1, name: "reference_data", kind: "message", T: ReferenceData },
    { no: 2, name: "segment_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message identity.v1.CreateAndPromoteMerchantSettingsRequest
 */
export const CreateAndPromoteMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.CreateAndPromoteMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: CreateMerchantSettingsPayload },
    { no: 2, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "enum", T: proto3.getEnumType(MerchantSettingsSource), opt: true },
  ],
);

/**
 * @generated from message identity.v1.CreateAndPromoteMerchantSettingsResponse
 */
export const CreateAndPromoteMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.CreateAndPromoteMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.CreateSegmentRequest
 */
export const CreateSegmentRequest = proto3.makeMessageType(
  "identity.v1.CreateSegmentRequest",
  () => [
    { no: 1, name: "segment", kind: "message", T: CreateSegmentPayload },
    { no: 2, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "source", kind: "enum", T: proto3.getEnumType(MerchantSettingsSource), opt: true },
  ],
);

/**
 * @generated from message identity.v1.ChangeMerchantSettingsStatusRequest
 */
export const ChangeMerchantSettingsStatusRequest = proto3.makeMessageType(
  "identity.v1.ChangeMerchantSettingsStatusRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(MerchantSettingsStatus), opt: true },
    { no: 5, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.ChangeMerchantSettingsStatusResponse
 */
export const ChangeMerchantSettingsStatusResponse = proto3.makeMessageType(
  "identity.v1.ChangeMerchantSettingsStatusResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.CreateSegmentResponse
 */
export const CreateSegmentResponse = proto3.makeMessageType(
  "identity.v1.CreateSegmentResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.UpdateMerchantSettingsRequest
 */
export const UpdateMerchantSettingsRequest = proto3.makeMessageType(
  "identity.v1.UpdateMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: CreateMerchantSettingsPayload },
    { no: 2, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "field_mask", kind: "message", T: FieldMask },
    { no: 6, name: "source", kind: "enum", T: proto3.getEnumType(MerchantSettingsSource), opt: true },
  ],
);

/**
 * @generated from message identity.v1.UpdateMerchantSettingsResponse
 */
export const UpdateMerchantSettingsResponse = proto3.makeMessageType(
  "identity.v1.UpdateMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message identity.v1.DeleteSegmentRequest
 */
export const DeleteSegmentRequest = proto3.makeMessageType(
  "identity.v1.DeleteSegmentRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.DeleteSegmentResponse
 */
export const DeleteSegmentResponse = proto3.makeMessageType(
  "identity.v1.DeleteSegmentResponse",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "segment", kind: "message", T: Segment, repeated: true },
  ],
);

/**
 * @generated from message identity.v1.GetStratusConfigForJpmppMidRequest
 */
export const GetStratusConfigForJpmppMidRequest = proto3.makeMessageType(
  "identity.v1.GetStratusConfigForJpmppMidRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetStratusConfigForJpmppMidResponse
 */
export const GetStratusConfigForJpmppMidResponse = proto3.makeMessageType(
  "identity.v1.GetStratusConfigForJpmppMidResponse",
  () => [
    { no: 1, name: "stratus_config", kind: "message", T: StratusConfiguration, repeated: true },
  ],
);

/**
 * @generated from message identity.v1.CreateExperimentRequest
 */
export const CreateExperimentRequest = proto3.makeMessageType(
  "identity.v1.CreateExperimentRequest",
  () => [
    { no: 1, name: "experiment", kind: "message", T: CreateExperimentPayload },
    { no: 2, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.CreateExperimentResponse
 */
export const CreateExperimentResponse = proto3.makeMessageType(
  "identity.v1.CreateExperimentResponse",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
  ],
);

/**
 * @generated from message identity.v1.GetActiveExperimentRequest
 */
export const GetActiveExperimentRequest = proto3.makeMessageType(
  "identity.v1.GetActiveExperimentRequest",
  () => [
    { no: 1, name: "control_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetActiveExperimentResponse
 */
export const GetActiveExperimentResponse = proto3.makeMessageType(
  "identity.v1.GetActiveExperimentResponse",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
  ],
);

/**
 * @generated from message identity.v1.GetAllExperimentsRequest
 */
export const GetAllExperimentsRequest = proto3.makeMessageType(
  "identity.v1.GetAllExperimentsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message identity.v1.GetAllExperimentsResponse
 */
export const GetAllExperimentsResponse = proto3.makeMessageType(
  "identity.v1.GetAllExperimentsResponse",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment, repeated: true },
  ],
);

/**
 * @generated from message identity.v1.UpdateExperimentRequest
 */
export const UpdateExperimentRequest = proto3.makeMessageType(
  "identity.v1.UpdateExperimentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ExperimentStatus), opt: true },
  ],
);

/**
 * @generated from message identity.v1.UpdateExperimentResponse
 */
export const UpdateExperimentResponse = proto3.makeMessageType(
  "identity.v1.UpdateExperimentResponse",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message identity.v1.GetExperimentResultsRequest
 */
export const GetExperimentResultsRequest = proto3.makeMessageType(
  "identity.v1.GetExperimentResultsRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_date", kind: "message", T: Date },
    { no: 3, name: "end_date", kind: "message", T: Date },
  ],
);

/**
 * @generated from message identity.v1.GetExperimentResultsResponse
 */
export const GetExperimentResultsResponse = proto3.makeMessageType(
  "identity.v1.GetExperimentResultsResponse",
  () => [
    { no: 1, name: "experiment_with_results_list", kind: "message", T: ExperimentWithResults },
  ],
);

/**
 * @generated from message identity.v1.GetExperimentResultsListRequest
 */
export const GetExperimentResultsListRequest = proto3.makeMessageType(
  "identity.v1.GetExperimentResultsListRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message identity.v1.GetExperimentResultsListResponse
 */
export const GetExperimentResultsListResponse = proto3.makeMessageType(
  "identity.v1.GetExperimentResultsListResponse",
  () => [
    { no: 1, name: "experiment_with_results_list", kind: "message", T: ExperimentWithResults, repeated: true },
  ],
);

